module.exports = __webpack_public_path__ + "assets/img/commission2.4384c8a3.svg";